<template>
    <div>
        <base-header type="gradient-success" class="pb-7">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h1 class="d-inline-block mb-0">Assets</h1>
                    <!--                    <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                                            <route-bread-crumb></route-bread-crumb>
                                        </nav>-->
                </div>
                <div class="col-lg-6 col-5 text-right">
                    <!--                                        <base-button size="sm" type="neutral">New</base-button>
                                                            <base-button size="sm" type="neutral">Filters</base-button>-->
                </div>
            </div>
            <!-- Card stats -->
<!--            <div class="row">
                <div class="col-xl-4 col-md-6">
                    <IncidentsOpen title="Offene"></IncidentsOpen>
                </div>
                <div class="col-xl-4 col-md-6">
                    <IncidentsToday title="Heute fällig"></IncidentsToday>
                </div>
                <div class="col-xl-4 col-md-6">
                    <IncidentsClosed title="Geschlossene"></IncidentsClosed>
                </div>
            </div>-->
        </base-header>
        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <AssetsTable title="Assets"></AssetsTable>
                </div>
            </div>
        </div>
        <div class="container-fluid">
            <div class="row">
                <div class="col">
                    <AssetsTree></AssetsTree>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Card from '@/components/Cards/Card';
import IncidentsToday from "@/views/Widgets/IncidentsToday";
import IncidentsOpen from "@/views/Widgets/IncidentsOpen";
import IncidentsClosed from "@/views/Widgets/IncidentsClosed";
import AssetsTree from "@/views/Widgets/AssetsTree";
import AssetsTable from '@/views/Tables/AssetsTable';
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";

export default {
    name: 'Statistics',
    components: {
        Card,
        IncidentsToday,
        IncidentsOpen,
        IncidentsClosed,
        RouteBreadCrumb,
        AssetsTree,
        AssetsTable,
    },
};
</script>
<style scoped lang="scss">
tbody tr {
    cursor: pointer;
}
</style>


